export const login_success = (data) => ({ type: 'LOGIN_SUCCESS', data });


export const logout = () => ({ type: 'LOG_OUT' });

// cw: store global items in redux to avoid page lag
export const set_connect_meet_label = (label) => ({ type: 'SET_CONNECT_MEET_LABEL', label });
